import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32860c9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-header" }, "Movies", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("History")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Watch List")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-header" }, "Musicals", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("History")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Listen List")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-header" }, "Other", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Stats")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Graph")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/movies/history",
      class: "menu-item",
      to: "/movies/history"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/movies/watch",
      class: "menu-item",
      to: "/movies/watch"
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_4,
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/musicals/history",
      class: "menu-item",
      to: "/musicals/history"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/musicals/listen",
      class: "menu-item",
      to: "/musicals/listen"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["onClick"]),
    _hoisted_7,
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/stats",
      class: "menu-item",
      to: "/stats"
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_router_link, {
      onClick: _ctx.handleClick,
      key: "/graph",
      class: "menu-item",
      to: "/graph"
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
}